import React from 'react'

interface IContent extends React.PropsWithChildren<unknown> {
  className: string
}
export const RWDContent = (props: IContent) => {
  return (
    <div {...props} className={props.className}>
      {props.children}
    </div>
  )
}
